import React, { createContext, memo } from "react";
import _get from "lodash/get";
import { useIsProjectClosed } from "../components/hooks/useIsProjectClosed";

// import PropTypes from "prop-types";

export const LabeledTextContext = createContext(false);

/**
 * A public higher-order component to disable multiple fields.
 *
 * `unlockOnIssued` opts a subtree out of the "Issued PO with no change order" lock only.
 * Used by the Shipping card, which stays editable in that state (BW-7002). An awarded spec
 * and a closed project keep locking regardless.
 */
function withLabeledTextOption(
  WrappedComponent,
  { unlockOnIssued = false } = {}
) {
  const LabeledTextWrapper = ({ purchaseOrder, initialValues, ...props }) => {
    const status = _get(purchaseOrder, "status");
    const revisionStatus = _get(purchaseOrder, "revisionStatus");
    const awardedTo = _get(initialValues, "awardedBidGroupVendorSpecQuoteId");
    const isProjectClosed = useIsProjectClosed();
    const isIssuedWithoutChangeOrder = status === "Issued" && !revisionStatus;
    const value =
      awardedTo ||
      (!unlockOnIssued && isIssuedWithoutChangeOrder) ||
      isProjectClosed;

    return (
      <LabeledTextContext.Provider value={value}>
        <WrappedComponent
          purchaseOrder={purchaseOrder}
          initialValues={initialValues}
          {...props}
        />
      </LabeledTextContext.Provider>
    );
  };

  LabeledTextWrapper.propTypes = {};
  return memo(LabeledTextWrapper);
}
export default withLabeledTextOption;
